<template>
  <SSection
    v-if="deals && deals.items.length > 0"
    :desktop-full="true"
    :title="t('views.cottage.deals.title')"
  >
    <SDeals v-bind="deals" />
  </SSection>
</template>

<script setup lang="ts">
import type { CottagePage } from '../../entities/CottagePage'
import { useToSDeals } from '~/composables/transformers/useToSDeals'

type itemType = Pick<CottagePage, 'deals' | 'province' | 'slug'>

interface propsInterface {
  item: itemType
}

let deals: any = null

const props = defineProps<propsInterface>()

if (props.item.deals) {
  deals = useToSDeals().fromRuralityCottageDealsDetail({
    dataIn: props.item.deals,
    province: props.item.province.slug,
    slug: props.item.slug,
  })
}
</script>
